import { forEach, findIndex, flatten } from 'lodash';
import axios from 'axios';

import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { PurchaseMethods } from '@sm360/widget-commons-vehicle';

import * as BODY_STYLES from 'catalog/constants/bodyStyles.js';
import bodyStyleTypes from 'catalog/constants/bodyStylesTypes.js';

const { PurchaseMethodsValues, PaymentFrequencyService } = PurchaseMethods;

function getBodyStyleLabel(bodyStyleType) {
    let label = '';

    switch (bodyStyleType) {
        case BODY_STYLES.SEDAN.TYPE:
            label = LocaleService.t('FILTER.BODY_STYLE.SEDAN');
            break;

        case BODY_STYLES.COUPE.TYPE:
            label = LocaleService.t('FILTER.BODY_STYLE.COUPE');
            break;

        case BODY_STYLES.HATCHBACK.TYPE:
            label = LocaleService.t('FILTER.BODY_STYLE.HATCHBACK');
            break;

        case BODY_STYLES.CONVERTIBLE.TYPE:
            label = LocaleService.t('FILTER.BODY_STYLE.CONVERTIBLE');
            break;

        case BODY_STYLES.SUV.TYPE:
            label = LocaleService.t('FILTER.BODY_STYLE.SUV');
            break;

        case BODY_STYLES.VAN.TYPE:
            label = LocaleService.t('FILTER.BODY_STYLE.VAN');
            break;

        case BODY_STYLES.COMMERCIAL.TYPE:
            label = LocaleService.t('FILTER.BODY_STYLE.COMMERCIAL');
            break;

        case BODY_STYLES.PICKUP.TYPE:
            label = LocaleService.t('FILTER.BODY_STYLE.PICKUP');
            break;

        case BODY_STYLES.PASSENGERVAN.TYPE:
            label = LocaleService.t('FILTER.BODY_STYLE.PASSENGERVAN');
            break;

        case BODY_STYLES.CREWVAN.TYPE:
            label = LocaleService.t('FILTER.BODY_STYLE.CREWVAN');
            break;

        default:
            break;
    }

    return label;
}

function getBodyStyleCustomLabel(bodyStyleType, bodyStyleCustom) {
    const selectedBodyStyle = bodyStyleCustom.find((bodyStyle) => bodyStyle.name === bodyStyleType);
    return selectedBodyStyle?.name;
}

export function getPurchaseMethodSortDropDownValues() {
    return [
        {
            value: PurchaseMethodsValues.LEASE | PurchaseMethodsValues.FINANCE,
            label: LocaleService.t('FILTER.PURCHASE_METHOD_ORDER.BEST_PAYMENT'),
        },
        {
            value: PurchaseMethodsValues.LEASE,
            label: LocaleService.t('FILTER.PURCHASE_METHOD_ORDER.LEASE_PAYMENT'),
        },
        {
            value: PurchaseMethodsValues.FINANCE,
            label: LocaleService.t('FILTER.PURCHASE_METHOD_ORDER.FINANCE_PAYMENT'),
        },
        {
            value: PurchaseMethodsValues.CASH,
            label: LocaleService.t('FILTER.PURCHASE_METHOD_ORDER.CASH_PURCHASE_PRICE'),
        },
    ];
}

export function translateFilters(catalogFilter, customBodyStyle) {
    return catalogFilter
        .set('purchaseMethodOrderValues', getPurchaseMethodSortDropDownValues())
        .set('paymentFrequencyValues', PaymentFrequencyService.getPaymentFrequencyDropDownValues(LocaleService))
        .set(
            'bodyStyles',
            catalogFilter
                .get('bodyStyles')
                .map((body) =>
                    body.set(
                        'label',
                        customBodyStyle
                            ? getBodyStyleCustomLabel(body.type, customBodyStyle)
                            : getBodyStyleLabel(body.type)
                    )
                )
        );
}

export function setBodyStylesFilter(catalogFilter, selectedBodyStyles) {
    const bodyStyles = catalogFilter.get('bodyStyles').map((bodyStyle) => {
        const isSelected =
            findIndex(selectedBodyStyles, (selectedBodyStyle) => {
                return selectedBodyStyle.value === bodyStyle.value;
            }) !== -1;

        return bodyStyle.set('selected', bodyStyle.selected && isSelected ? true : isSelected);
    });

    const filteredBodyStyles = bodyStyles.filter((body) => body.selected).toArray();
    const selectedBodyStyleCodes = [];
    forEach(filteredBodyStyles, (body) => {
        forEach(body.get('codes'), (code) => {
            selectedBodyStyleCodes.push(code);
        });
    });

    return catalogFilter
        .set('bodyStylesFilterAll', selectedBodyStyles.size === 0)
        .set('bodyStylesFilterCodes', selectedBodyStyleCodes)
        .set('bodyStyles', bodyStyles);
}

export async function getCatalogFiltersGroups() {
    const windowProxy = WindowProxy.get();
    const config = {
        headers: { authorization: `Basic c20zNjA6c20zNjA=` },
    };
    const apiUrl = `/${LocaleService.getSimpleLocale()}/api/catalog-filters-groups`;
    const location =
        windowProxy.location.hostname === 'localhost' ? 'www.spinellihonda.com' : windowProxy.location.hostname;

    const urlComplete = `https://${location.concat(apiUrl)}`;

    try {
        const response = await axios.get(urlComplete, config);
        const apiResponse = response?.data;

        const hybridElectricType = ['Hybrids/Electrics', 'Hybrids', 'Electrics', 'Hybrid', 'Electric'];

        const catalogFilterWithCodes = apiResponse.map((catalogFilter, index) => {
            const codes = [];
            if (!hybridElectricType.includes(catalogFilter.nameEn)) {
                catalogFilter.bodyStyles.forEach((bodyStyle) => {
                    const fondBodyStyle = bodyStyleTypes.find((styleTypes) => bodyStyle.key === styleTypes.type);
                    if (fondBodyStyle) codes.push(fondBodyStyle.CODES);
                });
            }
            if (hybridElectricType.includes(catalogFilter.nameEn)) {
                codes.push('HE');
            }
            return {
                ...catalogFilter,
                codes: flatten(codes),
                priority: index,
            };
        });
        return Promise.resolve(catalogFilterWithCodes);
    } catch (e) {
        return Promise.reject(e);
    }
}
